import { useCallback, useEffect, useMemo, useState } from "react"

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

function hookTagsFactory() {
  return ({ fetch, lists, siteSelected: { key: siteKey, id: siteId } }) => {
    const [items, setItems] = useState([])

    const list = useCallback(async () => {
      const data = await fetch({
        url: `cms-builder/blocks/tags`,
        params: {
          [siteKey]: siteId,
        },
      })
      setItems(data.map(tag => ({ tag })))
      return data
    }, [fetch, siteKey, siteId])

    return useMemo(() => {
      const store = {
        items,
        list,
        useLoad: () => {
          useEffect(() => {
            list()
          }, [])

          return useCallback(() => list(), [])
        },
      }

      return {
        lists: {
          ...lists || {},
          tags: store,
        },
      }
    }, [items, list, lists])
  }
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory("siteId"))
  .extendHookCollectionFactory("cms-builder/block")
  .extendHookCollectionsFactory("cms-builder/blocks")
  .extend(hookTagsFactory())
  .factory()

export {
  Provider as BuilderBlocksProvider,
  useStore as useBuilderBlocksStore,
}
